var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-price.j2"] = require( "macros/product-price.j2" );
dependencies["progression-arrow.j2"] = require( "progression-arrow.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/shoppable/shoppable-product-tag.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-price.j2", false, "core/templates/contentful/shoppable/shoppable-product-tag.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayPricing")) {
var t_4 = t_1.displayPricing;
} else {
cb(new Error("cannot import 'displayPricing'")); return;
}
context.setVariable("displayPricing", t_4);
var t_5;
t_5 = (lineno = 2, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "shoppableProduct"),"fields.product"]));
frame.set("product", t_5, true);
if(frame.topLevel) {
context.setVariable("product", t_5);
}
if(frame.topLevel) {
context.addExport("product", t_5);
}
var t_6;
t_6 = (lineno = 3, colno = 32, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "product"),"productName"]));
frame.set("productName", t_6, true);
if(frame.topLevel) {
context.setVariable("productName", t_6);
}
if(frame.topLevel) {
context.addExport("productName", t_6);
}
output += "<div class=\"c-shoppable-image__product-tag\">\n\n    <div class=\"c-shoppable-image__product-tag-inner\">\n\n        <p class=\"c-shoppable-image__product-name\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "productName"), env.opts.autoescape);
output += "</p>\n\n        <p class=\"c-shoppable-image__product-price\">\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"isSoldOut")) {
output += "\n\n                ";
output += runtime.suppressValue((lineno = 15, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["shoppable-image_tag-sold-out"])), env.opts.autoescape);
output += "\n\n            ";
;
}
else {
output += "\n\n                ";
output += runtime.suppressValue((lineno = 19, colno = 31, runtime.callWrap(t_4, "displayPricing", context, [runtime.contextOrFrameLookup(context, frame, "product"),runtime.contextOrFrameLookup(context, frame, "core")])), env.opts.autoescape);
output += "\n\n            ";
;
}
output += "\n\n        </p>\n\n        ";
env.getTemplate("progression-arrow.j2", false, "core/templates/contentful/shoppable/shoppable-product-tag.j2", null, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
t_7.render(context.getVariables(), frame, function(t_10,t_8) {
if(t_10) { cb(t_10); return; }
output += t_8
output += "\n\n    </div>\n\n    <div class=\"c-shoppable-image__product-tag-triangle\">";
output += "</div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/shoppable/shoppable-product-tag.j2"] , dependencies)